import React, { Fragment } from "react";

const TransportationResources = () => {
  return (
    <Fragment>
      <p className="f-h4 c-purple u-mb1">Find help from other organizations</p>
      <p>Visit our resource directory for transportation assistance and options from other organizations.</p>
      <p>
        <a className="btn" href="/transportation-directory">Transportation resource directory</a>
      </p>
    </Fragment>
  );
};

export default TransportationResources;
